import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

// Constants
import { unitsSizesRange, unitsPricesRange, unitsRoomsRange } from './consts/units-range';

/**
 * enums
*/
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

/**
 * 
 */
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';

/**
 * interfaces
*/
import { ICity } from 'src/app/core/interfaces/location/city';
import { IArea } from 'src/app/core/interfaces/location/area';
import { ICategory } from 'src/app/core/interfaces/category/category';
import { ISubFeature, IMainFeature } from 'src/app/core/interfaces/ads/feature';
import { IAdvertisement, IAdvertisementResponse, IAdvertisementUnit, IBuildingAdvertisementUnits } from 'src/app/core/interfaces/ads/advertisement';

/**
 * types
 */
type IAdvertisementFullUnit = IAdvertisementUnit & IAdvertisement<ICity, IArea, ICategory, ISubFeature, IMainFeature>

@Component({
  selector: 'app-advertisement-units',
  templateUrl: './advertisement-units.component.html',
  styleUrls: ['./advertisement-units.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementUnitsComponent implements OnInit {


  // Inputs
  /**
   * classList
   */
  @Input({ alias: 'classList' }) public classList: string;
  
  /**
   * advertisementData
   */
  @Input({ alias: 'advertisementData', required: true }) public set advertisementData(data: IAdvertisementResponse) {

    
    /**
     * 
     */
    this.AdvertisementData = data;

    /**
     * 
     */
    if (this.IsBuilding) {
      
      this.AdvertisementData.units = data.units.map(U => {

        let { unit } = U;

        unit = unit.map(u => ({...data, ...u})) as any

        return {...U, unit}

      }) as any;

      /**
       * 
       */
      this.Units = this.AdvertisementData.units as any

    }
    else if (this.IsOffPlanSale) {

      /**
       * 
       */
      this.AdvertisementData.buildings = data.buildings.map(b => ({...data, ...b})) as any;
      this.Units = this.AdvertisementData.buildings as any
    }


  }

  // fields
  /**
   * 
   */
  private _form: UntypedFormGroup = null

  /**
   * 
   */
  private _units: Array<IBuildingAdvertisementUnits<IAdvertisementFullUnit> | IAdvertisementFullUnit> = []

  /**
   * AdvertisementData
   */
  public AdvertisementData: IAdvertisementResponse = null
  

  /**
   * 
   */
  constructor(
    private _fb: UntypedFormBuilder,
    private _adService: AdOperationService,
  ) {}

  /**
   * 
   */
  ngOnInit(): void {
    
    /**
     * init
     */
    this._form = this._fb.group({
      size: [null],
      price: [null],
      roomsCount: [null]
    })
    
  }

  // Getters & Setters

  /**
   * 
   * @returns 
   */
  public get filterForm(): UntypedFormGroup {
    return this._form
  }
  
  /**
   * IsBuilding
   * @description Check if Advertisement is @param CATEGOR_VALUE_TYPE.BL
   */
  public get IsBuilding(): boolean {

    // ES6 Destruction
    const { category: { type } } = this.AdvertisementData;
    
    return this._adService.isBuilding(type)

  }

  /**
   * IsOffPlanSale
   * @description Check if Advertisement is @param CATEGOR_VALUE_TYPE.OFF_PLAN
   */
  public get IsOffPlanSale(): boolean {

    // ES6 Destruction
    const { category: { type } } = this.AdvertisementData;
    
    return this._adService.isOffPlanSale(type)

  }  

  /**
   * Units
   */
  public get Units(): Array<IBuildingAdvertisementUnits<IAdvertisementFullUnit> | IAdvertisementFullUnit> {
    return this._units
  }
  
  public set Units(units: Array<IBuildingAdvertisementUnits<IAdvertisementFullUnit> | IAdvertisementFullUnit>) {
    this._units = units;
  }

  /**
   * 
   */
  public get floorsNumber(): string[] {
    return ['الأول', 'الثاني', 'الثالث', 'الرابع', 'الخامس', 'السادس', 'السابع', 'الثامن', 'التاسع', 'العاشر']
  }
  

  /**
   * unitsSizesRange
   */
  public get listOfUnitsSizesRange(): typeof unitsSizesRange {
    return unitsSizesRange
  }

  /**
   * unitsPricesRange
   */
  public get listOfUnitsPricesRange(): typeof unitsPricesRange {
    return unitsPricesRange
  }

  /**
   * unitsRoomsRange
   */
  public get listOfUnitsRoomsRange(): typeof unitsRoomsRange {
    return unitsRoomsRange
  }  


  // Methods  

  /**
   * 
   * @param data 
   */
  public floorsUnitsFilterFromTo() {

    // ES6 Destruction
    const { size, price, roomsCount } = this.filterForm.value;

    let result = [];

    if (this.IsBuilding) {
      
      /**
       * map in units to filter units by size & price & room, then after map => filter it to remove empty unit
       */
      result = this.AdvertisementData.units.map(bundled => {
        // ES6 Destruction
        let { unit, floor } = bundled;
  
        /**
         * filter units by every types
         */
        if (size != null) unit = unit.filter(u => this._filterByKey(u, 'size'));
        if (price != null) unit = unit.filter(u => this._filterByKey(u, 'price'));
        if (roomsCount != null) unit = unit.filter(u => this._filterByKey(u, 'roomsCount'));
         
        /**
         * 
         */
        return { ...bundled, unit};
  
  
      }).filter(f => f.unit.length > 0)

      /**
      * 
      */
      this.Units = [...result];
      
    }


  }

  /**
   * _filterBySize
   * @description filter by size between from & to
   */
  private _filterByKey(value: IAdvertisementUnit, key: string): boolean {

    // ES6 Destruction    
    const { from, to } = this.filterForm.value[key] || {}; 

    /**
     * 
     */
    return (value[key] >= from && value[key] <= (to != null ? to : value[key]))   

  }

  /**
   * _isBuildingAdvertisementUnits
   * @description for check any interfaces must implementation
   */
  public _isBuildingAdvertisementUnits(value: any): value is IBuildingAdvertisementUnits<IAdvertisementFullUnit> {

    /**
     * 
     */
    return this.IsBuilding;

  }

  /**
   * _isOffPlanSaleAdvertisementBuildings
   * @description for check any interfaces must implementation
   */
  public _isOffPlanSaleAdvertisementBuildings(value: any): value is IAdvertisementFullUnit {

    /**
     * 
     */
    return this.IsOffPlanSale;

  }  

}